import {
	Component,
	OnInit,
	ViewChild,
	TemplateRef
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import swal from "sweetalert2";
import * as _ from "lodash";
import { ToasterService } from 'angular2-toaster';
import * as _moment from 'moment';
import * as fromCommonStore from "../../../store";
import * as fromRootStore from "../../../reducers";
import { CommonService, CacService } from "../../../services";

const moment = _moment;

@Component({
	selector: "branchwise_cac",
	templateUrl: "./branchwiseCAC.component.html"
})
export class branchwiseCACComponent implements OnInit {
	@ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
	@ViewChild("snoRepTemplate") snoRepTemplate: TemplateRef<any>;
	@ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
	sourceList: any[];
	formData: any;
	sourceOption: any;
	sourceCtrl = new FormControl();
	branchOption: any;
	branchCtrl = new FormControl();
	valueCtrl = new FormControl();
	monthCtrl = new FormControl();

	page: any;
	rePage: any;
	sourceDataList: any[];
	suppressPaging: any;
	columns: any;
	reportColumns: any;
	scrollTimeout: any;
	filterData: any;
	filterPanel: any;
	branchList: any;
	tempRow: any = [];
	reportDataList: any = [];
	filterExpand: boolean;
	applyFilerClick: boolean;
	loadingIndicator: boolean;
	saveFlag: boolean;
    isLoadMask: Promise<any>;

	constructor(
		public store: Store<fromRootStore.State>,
		public commonService: CommonService,
		public cacService: CacService,
		public toasterService: ToasterService,

	) {
		this.sourceList = [];
		this.branchList = [];
		this.saveFlag = false;

		//  FILTER PROPERTIES
		this.filterData = {
			branch: "",
			branch_id: "",
			date: new Date()
		};

		this.sourceDataList = [];
		this.filterExpand = false;
		this.applyFilerClick = false;
		this.resetPage();
	}

	ngOnInit() {

		// SOURCE LIST GRID PROPERTIES
		this.page = {
			limit: 25,
			count: 0,
			offset: 0,
			orderBy: "",
			orderDir: "asc"
		};
		this.columns = [
			{
				name: "SNo",
				prop: "sno",
				width: 80,
				minWidth: 80,
				maxWidth: 80,
				cellClass: "cell-center",
				sortable: false,
				cellTemplate: this.snoTemplate
			},
			{
				name: "Source",
				width: 200,
				minWidth: 200,
				maxWidth: 200,
				prop: "reference_type"
			},
			{
				name: "Value",
				width: 150,
				minWidth: 150,
				maxWidth: 150,
				cellClass: 'cell-right',
				prop: "amount"
			},
			{
				name: "Action",
				width: 100,
				minWidth: 100,
				maxWidth: 100,
				prop: "sno",
				sortable: false,
				cellClass: "cell-center",
				cellTemplate: this.editDeleteTemplate
			}
		];

		// SOURCE REPORT GRID PROPERTIES
		this.rePage = {
			limit: 25,
			count: 0,
			offset: 0,
			orderBy: "",
			orderDir: "asc"
		};
		this.reportColumns = [
			{
				name: "Sources",
				width: 120,
				minWidth: 120,
				maxWidth: 120,
				prop: "reference_type"
			},
			{
				name: "Walkin",
				width: 120,
				minWidth: 120,
				maxWidth: 120,
				cellClass: 'cell-right',
				prop: "walkin",
				summary: 'sum'
			},
			{
				name: "No of Clients",
				width: 180,
				minWidth: 180,
				maxWidth: 180,
				cellClass: 'cell-right',
				prop: "sales_advance",
				summary: 'sum'
			},
			{
				name: "Conversion %",
				width: 150,
				minWidth: 150,
				maxWidth: 150,
				cellClass: 'cell-right',
				prop: "conversion",
				summary: 'conversion'
			},
			{
				name: "Sources Contribution %",
				width: 220,
				minWidth: 220,
				maxWidth: 220,
				cellClass: 'cell-right',
				prop: "contribution_total_sales"
			},
			{
				name: "Expenses",
				width: 120,
				minWidth: 120,
				maxWidth: 120,
				cellClass: 'cell-right',
				prop: "expense",
				summary: 'sum'
			},
			{
				name: "Sold Qty",
				width: 120,
				minWidth: 120,
				maxWidth: 120,
				cellClass: 'cell-right',
				prop: "soldQty",
				summary: 'sum'
			},
			{
				name: "CAC",
				width: 120,
				minWidth: 120,
				maxWidth: 120,
				cellClass: 'cell-right',
				prop: "cac"
			},
			{
				name: "AVG Bill Value",
				width: 120,
				minWidth: 120,
				maxWidth: 120,
				cellClass: 'cell-right',
				prop: "avg_bill_value"
			},
			{
				name: "CAC/AVG Bill Value",
				width: 180,
				minWidth: 180,
				maxWidth: 180,
				cellClass: 'cell-right',
				prop: "cac_avg_bill_value"
			},
			{
				name: "MRP Price",
				width: 120,
				minWidth: 120,
				maxWidth: 120,
				cellClass: 'cell-right',
				prop: "mrp",
				summary: 'sum'
			},
			{
				name: "Sold Price",
				width: 120,
				minWidth: 120,
				maxWidth: 120,
				cellClass: 'cell-right',
				prop: "sold_price",
				summary: 'sum'
			},
			{
				name: "ASP",
				width: 120,
				minWidth: 120,
				maxWidth: 120,
				cellClass: 'cell-right',
				prop: "asp"
			},
			{
				name: "CAC ASP %",
				width: 120,
				minWidth: 120,
				maxWidth: 120,
				cellClass: 'cell-right',
				prop: "cac_per_asp"
			},
		];

		// REFERENCE LIST PROPERTIES
		// this.store.select(fromCommonStore.getAllReference).subscribe((res: any) => {
		//   this.sourceList = res;
		// });

		this.commonService.getReferenceTypeList().subscribe(res => {
			this.sourceList = res.data;
		});

		this.sourceOption = this.sourceCtrl.valueChanges
			.startWith("")
			.map(name => (name ? this.filterHa(name) : this.sourceList.slice()));

		//-------------------------------- 

		// BRANCH LIST PROPERTIES
		this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
			this.branchList.push({ 'branch_id': -1, 'branch_name': "All" });
			res.data.map(branchObj => {
				if (branchObj.is_crm_branch == 'Yes' && branchObj.branch_name != 'HEAD OFFICE')
					this.branchList.push(branchObj);
			});
		});

		this.branchOption = this.branchCtrl.valueChanges
			.startWith("")
			.map(name => (name ? this.filterBranch(name) : this.branchList.slice()));
		this.filterData.branch_id = -1;
		this.applyFilter();

		// --------------------------------
	}

	resetPage() {
		this.formData = {
			source: "",
			reference_type: "",
			source_id: "",
			amount: ""
		};
	}

	// REFERENCE LIST PROPERTIES
	displayRef(item_id: number) {
		if (item_id && this.sourceList.length > 0) {
			let fitem: any = _.find(this.sourceList, { reference_type: item_id }),
				ref_name = fitem.reference_type ? fitem.reference_type : "";
			this.formData.source = fitem;
			return ref_name;
		}
		return "";
	}

	filterHa(name: string) {
		name = _.escapeRegExp(name);
		return this.sourceList.filter(ha =>
			new RegExp(name, "gi").test(ha.reference_type)
		);
	}
	// --------------------------------

	// BRANCH LIST PROPERTIES
	displayBranch(item_id: number) {
		if (item_id && this.branchList.length > 0) {
			let fitem: any = _.find(this.branchList, { branch_id: item_id }),
				ref_name = fitem.branch_name ? fitem.branch_name : "";
			this.filterData.branch = fitem;
			return ref_name;
		}
		return "";
	}

	filterBranch(name: string) {
		name = _.escapeRegExp(name);
		return this.branchList.filter(ha =>
			new RegExp(name, "gi").test(ha.branch_name)
		);
	}
	// --------------------------------

	//  APPLY FILTER FUNCTION
	applyFilter() {
		this.applyFilerClick = true;
		this.loadingIndicator = true;
		let param = {
			branch: (this.filterData.branch.branch_id) ? this.filterData.branch.branch_id : this.filterData.branch_id,
			month: moment(this.filterData.date).format('YYYY-MM')
		};
		this.isLoadMask = this.cacService.getBranchCACAmount(param).then((res: any) => {
			this.sourceDataList = res.data;
			this.page.count = res.totCnt;
			this.loadingIndicator = false;
			this.getBranchReport(res.data);
		});
	}
	// ------------------


	// ADD SOURCE FUNCTION
	addSourceValue() {
		let toast = {
			type: 'warning',
			title: 'WARNING'
		};

		if (this.filterData.branch == "") {
			toast['body'] = 'Please Select Valid Branch';
			this.toasterService.pop(toast);
			this.filterExpand = true;
			setTimeout(() => {
				$('#' + 'branchId').focus();
			}, 100);
			return;
		}
		if (this.filterData.branch == -1) {
			toast['body'] = 'Action not performed in this Branch';
			this.toasterService.pop(toast);
			return false;
		}
		if (this.filterData.date == "") {
			toast['body'] = 'Please Select Valid Month';
			this.toasterService.pop(toast);
			this.filterExpand = true;
			setTimeout(() => {
				$('#' + 'branchDate').focus();
			}, 100);
			return;
		}
		if (!this.applyFilerClick) {
			toast['body'] = 'Please Select Branch and Click Apply Button!';
			this.toasterService.pop(toast);
			this.filterExpand = true;
			return;
		}
		if (!this.formData.source) {
			toast['body'] = 'Please Select Valid Source';
			this.toasterService.pop(toast);
			$('#' + 'sourceName').focus();

			return;
		}
		// if (!this.formData.value) {
		//   toast['body'] = 'Please Enter Amount';
		//   this.toasterService.pop(toast);
		//   $('#' + 'amount').focus();

		//   return;
		// }

		if (this.sourceDataList.length > 0) {
			if (this.sourceDataList.find(res => res.reference_id == this.formData.source.ref_id)) {
				swal("WARNING", "Source Already exist!!");
				return;
			}
		}

		let param = {
			month: moment(this.filterData.date).format('YYYY-MM-DD'),
			branch_id: this.filterData.branch.branch_id,
			branch_name: this.filterData.branch.branch_name,
			reference_id: this.formData.source.ref_id,
			reference_type: this.formData.source.reference_type,
			amount: this.formData.value
		};
		this.sourceDataList.push(param);
		this.page.count = this.sourceDataList.length;
		this.resetPage();
	}
	// ------------------------


	// SACE SOURCE VALIDATION
	validate() {
		let flag = true;
		if (this.sourceDataList.length > 0 && this.filterData.branch_id) {
			flag = false;
		}
		return flag;
	}
	// ------------

	checkDataCount() {
		return (this.reportDataList.length > 0) ? false : true;
	}

	// SAVE SOURCE FUNCTION
	saveSourceValue(isStopReload: boolean) {
		let that = this;
		let param = {
			flag: this.saveFlag,
			data: JSON.stringify(this.sourceDataList)
		};
		this.cacService.saveBranchCACAmount(param).then((res: any) => {
			if (res.type == 'WARNING') {
				swal({
					title: res.type,
					text: res.message,
					showCancelButton: true,
					cancelButtonText: 'No',
					confirmButtonText: 'Yes',
				}).then(function () {
					that.saveFlag = true;
					that.saveSourceValue(true);
				});
			} else {
				this.saveFlag = false;
				swal(res.type, res.message);
				if (!isStopReload) {
					this.getBranchReport(this.sourceDataList);
				}
			}
		});
	}
	// ------------

	// DELETE SOURCE

	deleteSource(row, ind) {
		let that = this;
		swal({
			title: "WARNING",
			text: "Do you want to Delete this Reference?",
			showCancelButton: true,
			cancelButtonText: 'No',
			confirmButtonText: 'Yes',
		}).then(function () {
			if (row.branch_cac_id) {
				that.cacService.deleteBranchAmount(row).then((res: any) => {
					if (res.success) {
						swal("SUCCESS", res.message);
						that.sourceDataList.splice(ind, 1);
					} else {
						var toast = {
							type: 'error',
							title: 'ERROR',
							body: res.message
						};
						that.toasterService.pop(toast);
					}
				});
			}
		});
	}

	// -----------

	// BRANCH CAC REPORT LIST
	getBranchReport(data) {
		let param = {
			data: JSON.stringify(data)
		};
		let that = this;
		this.loadingIndicator = true;
		this.isLoadMask = this.cacService.getBranchCACReport(param).then((res: any) => {
			this.loadingIndicator = false;
			that.reportDataList = res.data;
			that.rePage.count = res.totCnt;
			if (that.reportDataList.length > 0) {
				// TO CHECK FOOTER
				that.footerRow();
			}
		});
	}

	footerRow() {
		const that = this,
			columns = this.reportColumns,
			footArr = {};

		for (let i = 0; i < columns.length; i++) {
			const propName = columns[i].prop
			if (columns[i].summary == 'sum') {
				let tot_sum = 0;
				_.forEachRight(that.reportDataList, function (value) {
					tot_sum += value[propName] ? +value[propName] : 0;
				});
				if (tot_sum > 0) {
					footArr[propName] = tot_sum;
				}
			}
		}

		// if(footArr.length > 0) {
		footArr["footRow"] = true;
		footArr["conversion"] = ((footArr["sales_advance"] / footArr["walkin"]) * 100).toFixed(2);
		footArr["cac"] = (footArr["expense"] / footArr["soldQty"]).toFixed(2);
		footArr["avg_bill_value"] = (footArr["sold_price"] / footArr["soldQty"]).toFixed(2);
		footArr["cac_avg_bill_value"] = ((footArr["cac"] / footArr["avg_bill_value"]) * 100).toFixed(2);
		footArr["asp"] = (footArr["mrp"] / footArr["soldQty"]).toFixed(2);
		footArr["cac_per_asp"] = ((footArr["cac"] / footArr["asp"]) * 100).toFixed(2);
		that.reportDataList.push(footArr);
		that.rePage.count += 1;
		that.rePage.limit += 1;
		// }
	}
	// -----------------
	/**
		* TO CHANGE SPECIFIC ROW COLOR
		*/
	getRowClass(row) {
		return {
			'grid-foot-total-row': row.footRow == true
		};
	}

	onClickExcelBtn() {
		// setTimeout(function () {
		//   that.filterPanel.close();
		// }, 10);
		let that = this,
			data = {
				columns: JSON.stringify(this.reportColumns),
				data: JSON.stringify(this.reportDataList),
				title: "Branchwise CAC Report"
			};
		this.commonService
			.printing(data)
			.then(function (res: any) {
				if (res['_body']) {
					var headers = res['headers']["_headers"],
						ctype = headers.get('content-type')[0],
						cdispos = headers.get('content-disposition')[0],
						filename = cdispos.replace(/attachment;filename=|"/gi, ''),
						blob = new Blob([res['_body']], {
							type: ctype
						}),
						link = document.createElement('a');

					link.href = window.URL.createObjectURL(blob);
					link.download = filename;
					link.click();
				} else {
					var toast = {
						type: 'error',
						title: 'ERROR',
						body: res.message
					};
					that.toasterService.pop(toast);
				}
			});
	}
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/management/branchwise_cac/branchwiseCAC.component.ts